import { render, staticRenderFns } from "./ListaOrdenCompras.vue?vue&type=template&id=11162d06&"
import script from "./ListaOrdenCompras.vue?vue&type=script&lang=js&"
export * from "./ListaOrdenCompras.vue?vue&type=script&lang=js&"
import style0 from "./ListaOrdenCompras.vue?vue&type=style&index=0&id=11162d06&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports